import ActionsPanel from './ActionsPanel';

export default ActionsPanel;



// WEBPACK FOOTER //
// ./src/components/ActionsPanel/index.js